<template>
  <div>
    <v-dialog width="500" v-model="dialog">
      <v-card>
        <v-btn absolute style="right: 0" class="mt-1" icon @click="close">
          <v-icon>mdi-close</v-icon>
        </v-btn>
        <v-card-title>{{ $t("moveProduct") }}</v-card-title>
        <v-card-text>
          <validation-observer ref="formObs" v-slot="{ handleSubmit }">
            <form @submit.prevent="handleSubmit(onSubmit)">
              <vue-select
                ref="warehouseSelectRef"
                infinite
                @CHANGE_VALUE="onChangeWarehouse"
                rules="required"
                @item-resolved="setWarehouse"
                @next-page-resolved="
                  (data) => setWarehouse([...warehouseList, ...data])
                "
                :get-item-promise="
                  ({ text, page }) =>
                    $store.dispatch('getWareHouses', {
                      page,
                      name: text,
                      limit: 15,
                    })
                "
                v-model="moveProduct.warehouseId"
                :items="warehouseList"
                :label="$t('warehouse')"
                class="product-select-in-modal"
              ></vue-select>
              <v-checkbox
                dense
                :label="$t('moveToWarehouse')"
                :value="true"
                v-model="moveProduct.returnToWarehouse"
                :true-value="true"
                :false-value="false"
                hide-details
                class=""
              ></v-checkbox>
              <template v-if="moveProduct.returnToWarehouse">
                <v-checkbox
                  dense
                  v-model="moveProduct.used"
                  :label="$t('used')"
                  hide-details
                  class="mt-0"
                ></v-checkbox>
                <custom-text-textarea
                  rules="required"
                  :label="$t('comment')"
                  class="user_input mb-4"
                  v-model="moveProduct.comments"
                ></custom-text-textarea>
                <validation-provider
                  v-slot="{ errors }"
                  :name="$t('file')"
                  rules="required|document|not_empty_file"
                >
                  <v-file-input
                    dense
                    style="margin: 0"
                    v-model="moveProduct.file"
                    :error-messages="errors[0]"
                    :label="$t('attachFile') + '*'"
                  ></v-file-input>
                </validation-provider>
              </template>
              <v-list dense>
                <v-list-item
                  class="px-0 d-block"
                  v-for="(product, productIndex) in items"
                  :key="`product-${productIndex}`"
                >
                  <v-list-item-content class="py-2">
                    <v-list-item-title>{{
                      product.productName
                    }}</v-list-item-title>
                    <v-list-item-subtitle
                      >{{ product.count
                      }}{{ product.unitType }}</v-list-item-subtitle
                    >
                  </v-list-item-content>
                  <!--                  <custom-input-text-->
                  <!--                    v-if="selectedItemsNumber == 1"-->
                  <!--                    :loading="loading"-->
                  <!--                    :label="$t('qrCode')"-->
                  <!--                    v-model="moveProduct.qrCode"-->
                  <!--                    rules="required"-->
                  <!--                    class="user_input no-margin"-->
                  <!--                  ></custom-input-text>-->
                  <custom-input-text
                    v-if="selectedItemsNumber === 1"
                    :loading="loading"
                    :label="$t('givenProductQuantity')"
                    v-model="moveProduct.count"
                    :rules="{ required: true, max_value: product.count }"
                    class="user_input no-margin"
                  ></custom-input-text>
                </v-list-item>
              </v-list>

              <div class="text-right py-4">
                <v-btn :loading="loading" type="submit" color="primary">{{
                  $t("save")
                }}</v-btn>
              </div>
            </form>
          </validation-observer>
        </v-card-text>
      </v-card>
    </v-dialog>
    <warning-dialog
      yes-text="yes"
      description="moveProductConfirmDesc"
      v-model="warningDialog"
      @apply="submit"
      ref="warningDialog"
    ></warning-dialog>
  </div>
</template>

<script>
import VueSelect from "@/components/ui/vue-select/VueSelect.vue";
import WarningDialog from "@/components/ui/prompt/warning-dialog.vue";

export default {
  name: "ProductMoveToOtherDepartment",
  components: { WarningDialog, VueSelect },
  data() {
    return {
      loading: false,
      dialog: false,
      warningDialog: false,
      items: [],
      warehouseList: [],
      isSelectedOMTKWarehouse: false,
      moveProduct: {
        warehouseId: null,
        returnToWarehouse: false,
        productIds: [],
        qrCode: null,
        count: null,
        used: false,
        comments: null,
        file: null,
      },
    };
  },
  props: ["selectedItemsNumber"],
  watch: {
    dialog(val) {
      const { formObs } = this.$refs;
      if (!val) {
        formObs.reset();
        this.moveProduct = {
          warehouseId: null,
          returnToWarehouse: false,
          productIds: [],
          used: false,
          comments: null,
          file: null,
        };
      }
    },
  },
  methods: {
    setWarehouse(warehouses) {
      this.warehouseList = warehouses;
    },
    onChangeWarehouse(warehouse) {
      if (warehouse) {
        this.isSelectedOMTKWarehouse = warehouse.group === "OMTK";
      } else {
        this.isSelectedOMTKWarehouse = false;
      }
    },
    open(items) {
      this.dialog = true;
      this.items = items;
    },
    close() {
      this.dialog = false;
    },
    onSubmit() {
      this.warningDialog = true;
    },
    async submit() {
      this.loading = true;
      try {
        const {
          comments,
          used,
          returnToWarehouse,
          warehouseId,
          file,
          count,
          qrCode,
        } = this.moveProduct;
        const formData = new FormData();
        if (comments) formData.append("comments", comments);
        formData.append(
          "productIds",
          this.items.map((item) => item.id).join(",")
        );
        formData.append("returnToWarehouse", returnToWarehouse);
        formData.append("used", used);
        formData.append("warehouseId", warehouseId);
        if (count) formData.append("count", count);
        if (qrCode) formData.append("qrCode", qrCode);
        if (file) formData.append("file", file);
        await this.$http.post("product-item/forward", formData);
        this.close();
        this.setSuccess({ title: this.$t("successfullySaved") });
        this.$emit("UPDATED");
      } catch (e) {
        this.setResponseError({ error: e });
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
